import script from "./PrimarySelect.vue?vue&type=script&setup=true&lang=js"
export * from "./PrimarySelect.vue?vue&type=script&setup=true&lang=js"

import "./PrimarySelect.vue?vue&type=style&index=0&id=73ce3fbc&lang=scss"

const __exports__ = script;

export default __exports__